// @ts-nocheck

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { http } from "../../../engine/api/http";
import { renderUserName } from "../../../utils/constants";

const initialState = {
  prestations: [],
  totals: {
    draft: 0,
    schedules: 0,
    today: 0,
    min24h: 0,
    done: 0,
    nonClosed: 0,
    cancelled: 0,
    total: 0,
  },
  loading: false,
  interpretes: [],
  institutionsFilter: [],
  value: 0,
};

export const getPrestations = createAsyncThunk(
  "posts/getPrestations",
  async (payload, thunkAPI) => {
    const { search } = payload;
    const res = await http.get(`/prestations/tab?${search}`);
    return res.data;
  },
);

const prestationsSlice = createSlice({
  name: "prestations",
  initialState,
  reducers: {
    increment: state => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value += 1;
    },
    decrement: state => {
      state.value -= 1;
    },
    incrementByAmount: (state, action) => {
      state.value += action.payload;
    },
  },
  extraReducers: {
    [getPrestations.pending]: state => {
      state.loading = true;
    },
    [getPrestations.fulfilled]: (state, { payload }) => {
      state.loading = false;

      // Check if the interpretes list is empty
      // If empty, update it with the new interpretes
      // if (state.interpretes.length === 0) {
      const uniqueInterpretes = new Set();
      // state.interpretes = payload.prestations
      //   .map(prestation => {
      //     if (prestation.interprete !== null) {
      //       const userId = prestation.interprete._id;
      //       if (!uniqueInterpretes.has(userId)) {
      //         uniqueInterpretes.add(userId);
      //         return {
      //           label: renderUserName(prestation.interprete),
      //           value: userId,
      //         };
      //       }
      //     }
      //     return undefined;
      //   })
      //   .filter(Boolean);
      // }
      // const uniqueInstitutions = new Set();

      // let uniqueInstitu = payload.prestations
      //   .map(prestation => {
      //     if (
      //       prestation.institution !== null &&
      //       prestation.institution !== undefined
      //     ) {
      //       const institutionId = prestation.institution._id;
      //
      //       if (!uniqueInstitutions.has(institutionId)) {
      //         uniqueInstitutions.add(institutionId);
      //         return {
      //           label: prestation.institution.name,
      //           value: institutionId,
      //         };
      //       }
      //     }
      //     return undefined;
      //   })
      //   .filter(Boolean);

      // Check if the interpretes list is empty
      // If empty, update it with the new interpretes
      // if (state.institutionsFilter.length === 0) {
      //   state.institutionsFilter = uniqueInstitu;
      // } else {
      //   // Add more and merged institutions
      //   let current = state.institutionsFilter;
      //   current = current.concat(uniqueInstitu);
      //   state.institutionsFilter = uniqueInstitu;
      // }

      state.prestations = payload.prestations;
      state.totals = payload.totals;
    },
    [getPrestations.rejected]: (state, { payload }) => {
      localStorage.removeItem("prestationsSearcher");

      state.loading = false;
    },
  },
});

export const {
  increment,
  decrement,
  incrementByAmount,
  updateUnitOnList,
} = prestationsSlice.actions;

export const prestationsReducer = prestationsSlice.reducer;
